/**
 * src/api/dashboardsEstado.js
 * ¿Qué tenants tienen ya horneada la plantilla vigente del dashboard?
 *
 * El endpoint existe desde el Lote 6 y hasta el 31-08-2026 NO tenía pantalla:
 * solo lo podía consultar quien supiera lanzar una petición con `X-Admin-Token`.
 * El día que Manuel regeneró los nueve tenants y no vio ningún cambio, la
 * pregunta «¿le llegó el código nuevo a este tenant?» no se podía responder
 * desde el panel — que es justo donde se regenera.
 *
 * Los marcadores son ESTRUCTURALES: salen del código de la plantilla, no de los
 * datos del tenant, así que valen igual con 20 órdenes que con 20.000.
 */
import api from './client'

// Una fila por tenant. `solo_desactualizados` acota a los que faltan, que es la
// lista de trabajo real después de un despliegue.
export const listarEstadoDashboards = ({ soloDesactualizados = false } = {}) =>
  api.get('/admin/dashboards/estado',
    { params: { solo_desactualizados: soloDesactualizados } }).then(r => r.data)
